<template>
  <!--签署安全-->
  <div class="security">
    <!--<div class="nav-bar">
      <ul class="fr">
        <li v-if="$store.getters.authUser.userType !== 0" class="fl" :class="$route.path.indexOf('signPwd') !== -1 ? 'active' : ''">
          <nuxt-link :to="{path: '/signSettings/security/signPwd'}" class="item">签署密码</nuxt-link>
        </li>
        <li class="fl" :class="$route.path.indexOf('dc') !== -1 ? 'active' : ''">
          <nuxt-link :to="{path: '/signSettings/security/dc'}" class="item">君子盾</nuxt-link>
        </li>
      </ul>
    </div>-->

    <nuxt-child />
  </div>
</template>

<script>
  export default {
    name: "security"
  }
</script>

<style lang="less" scoped>
  .nav-bar {
    margin-bottom: 20px;
    border: 1px dashed #D7D7D7;
    overflow: hidden;

    ul {
      width: 100%;
      li .item {
        position: relative;
        display: inline-block;
        margin-right: 14px;
        padding: 10px;
        color: #666;
        border: none;
        background: #fff;
      }
      li.active .item{
        color: #ec1c1c;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// pages/signSettings/security.vue